import { Mood } from '@data/mood/Mood';
import { DateRangeCriteriaDTO } from '@data/common/DateRangeCriteriaDTO';

export namespace MoodActions {
  const prefix: string = '[Mood]';

  export class GetTodayMood {
    static readonly type = `${ prefix } Get today mood`;

    constructor() {
    }
  }

  export class GetMoodsForDateRange {
    static readonly type = `${ prefix } Get moods for date range`;

    constructor(public payload: DateRangeCriteriaDTO) {
    }
  }

  export class SelectTodayMood {
    static readonly type = `${ prefix } Select today mood`;

    constructor(public mood: Mood) {
    }
  }
}
